import React from 'react';
import { Row, Column } from 'react-foundation';

const Modal = ({
	Content,
	style,
	cta,
	modalState,
	turnOffModal,
	title,
	text,
	button_link,
	button_text,
	buttonFunction,
}) => {
	if (Content) {
		return (
			<div id="modal">
				<div
					className={
						modalState
							? 'modal-window-modal active'
							: 'modal-window-modal'
					}
				>
					<div
						className={
							modalState ? 'modal-window active' : 'modal-window'
						}
						style={style}
					>
						<Content />
					</div>
					<div
						className="modal-background"
						onClick={turnOffModal}
					></div>
				</div>
			</div>
		);
	}
	return (
		<div id="modal">
			<div
				className={
					modalState
						? 'modal-window-modal active'
						: 'modal-window-modal'
				}
			>
				<div
					className={
						modalState ? 'modal-window active' : 'modal-window'
					}
					style={style}
				>
					<Row>
						<Column small={12}>
							<div
								className={'modal-title' + (cta ? ' cta' : '')}
							>
								{title}
							</div>
							<div className="modal-text">{text}</div>
						</Column>
					</Row>
					<div className="button-holder">
						<Row>
							<Column small={12} medium={6}>
								<div
									className={
										'primary-button long' +
										(cta ? 'purchase-button' : '')
									}
									onClick={turnOffModal}
								>
									<p>CANCEL</p>
								</div>
							</Column>
							<Column small={12} medium={6}>
								<a
									className={
										'secondary-button long' +
										(cta ? 'purchase-button' : '')
									}
									href={button_link}
									onClick={buttonFunction}
								>
									<p>
										{button_text ? button_text : 'CONFIRM'}
									</p>
								</a>
							</Column>
						</Row>
					</div>
				</div>
				<div className="modal-background" onClick={turnOffModal}></div>
			</div>
		</div>
	);
};

export default Modal;
